import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const teacherRule = {
    teacherRule: {
        list: config => createAPI('/teacherRule/list', 'post', config),
        teaTypeOption: config => createAPI('/teacherRule/teaTypeOption', 'post', config),
        saveRec: config => createAPI('/teacherRule/saveRec', 'post', config),
    },

};


export default teacherRule;



// WEBPACK FOOTER //
// ./src/api/modules/teacherRule.js